<template>
  <v-dialog :value="show" width="500" @input="$emit('update:show', $event)">
    <v-card rounded="0" class="d-flex justify-center flex-column pa-6">
      <div class="d-flex justify-space-between align-center mx-2 mb-5">
        <v-icon color="error" x-large class="exit-warning-icon mr-4">mdi-alert</v-icon>
        <!-- Error message to block a user from deleting themselves -->
        <v-card-title class="word-break align-text-left exit-warning-text" v-if="isDeletingSelf">
          Uh oh! Looks like you're trying to delete yourself
        </v-card-title>
        <v-card-title
          class="word-break align-text-left exit-warning-text"
          v-else-if="selectedUsers.length != 1"
        >
          Are you sure you want to delete the selected users?
        </v-card-title>
        <v-card-title class="word-break align-text-left exit-warning-text" v-else>
          Are you sure you want to delete the selected user?
        </v-card-title>
      </div>

      <v-card-actions class="mx-12">
        <v-btn color="primary" @click="handleCancel" outlined width="140">{{
          isDeletingSelf ? "Exit" : "Don't delete"
        }}</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="handleDelete" width="140" v-if="!isDeletingSelf"
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteMultipleUsersDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedUsers: {
      type: Array,
      default: () => [],
    },
    currentUserId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isDeletingSelf() {
      return this.selectedUsers.map((x) => x.userId).includes(this.currentUserId);
    },
  },
  methods: {
    handleCancel() {
      this.$emit("update:show", false);
    },
    handleDelete() {
      this.$emit("delete");
    },
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
}
.align-text-left {
  text-align: left;
}
</style>
